/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Colors, Fonts, Media } from 'fowlit';

const weekdays = [
  { id: 1, label: 'M' },
  { id: 2, label: 'T' },
  { id: 3, label: 'O' },
  { id: 4, label: 'T' },
  { id: 5, label: 'F' },
  { id: 6, label: 'L' },
  { id: 7, label: 'S' }
];

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 30px 30px 1fr;
  grid-template-areas: 'month' 'labels' 'days';
  grid-gap: 5px;
  padding: 30px 30px 0 30px;
  @media (max-width: ${Media.phone}) {
    padding: 0;
  }
`;

const MonthLabel = styled.div`
  grid-area: month;
  display: grid;
  grid-template-columns: 30px 1fr 30px;
  grid-template-rows: 30px;
  grid-template-areas: 'prev label next';
  color: ${props => props.theme.searchbarColor};
  cursor: pointer;
  text-align: center;
  justify-content: space-between;

  i:nth-child(1) {
    grid-area: prev;
    line-height: 30px;
  }
  i:nth-child(3) {
    grid-area: next;
    line-height: 30px;
  }
  h5 {
    grid-area: label;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const WeekLabels = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: 1fr;
`;

const WeekLabel = styled.i`
  font-size: 0.7rem;
  color: ${props => (props.current ? props.theme.searchbarActive : props.theme.searchbarColor)};
  font-weight: ${Fonts.weightBold};
  display: flex;
  justify-content: space-evenly;
  align-items: flex-end;
`;

const Days = styled.div`
  grid-area: days;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(6, 1fr);
`;

const Day = styled.i`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 30px;
  width: 30px;
  font-size: 0.7rem;
  user-select: none;
  cursor: pointer;
  transition: 200ms ease-out;
  border-radius: ${props => (props.selectedAsFrom || props.selectedAsTo ? '50%' : '0')};
  ${props => {
    if (props.selectedAsFrom) {
      return `
        background: ${props.theme.searchbarActive};
        border-radius: 50% 0 0 50%;
        color: ${Colors.white};
      `;
    }
    if (props.selectedAsTo) {
      return `
        background: ${props.theme.searchbarActive};
        border-radius: 0 50% 50% 0;
        color: ${Colors.white};
      `;
    }
    if (props.today) {
      return `
        color: ${props.theme.searchbarActive};
        font-weight: ${Fonts.weightBold};
      `;
    }
    if (props.inInterval) {
      return `
        background: ${props.theme.searchbarActive};
        border-radius: 0;
        opacity: 0.5;
        color: ${Colors.white};
      `;
    }
    if (props.beforeCurrentDay) {
      return `
        opacity: 0.2;
        pointer-events: none;
        color: ${props.theme.searchbarColor};
      `;
    }
    return `
      color: ${props.theme.searchbarColor};
    `;
  }}
  &:hover {
    color: ${Colors.white};
    background: ${props => props.theme.searchbarActive};
    opacity: 1;
  }
`;

const getDaysOfMonth = date => {
  return new Date(new Date(date).getFullYear(), new Date(date).getMonth() + 1, 0).getDate();
};

const formatDate = (date, options) => {
  return new Date(date).toLocaleDateString('sv-SV', options);
};

const getOneMonthBefore = () => {
  const d = new Date();
  d.setMonth(d.getMonth() - 12);
  return d;
};

const Month = ({ hour, minutes, month, setLeftMonth, setRightMonth, onSelect, from, to }) => {
  const [options, setOptions] = useState({ month: 'short' });
  const [days, setDays] = useState(0);

  useEffect(() => {
    setOptions(
      new Date(month).getFullYear() === new Date().getFullYear()
        ? { month: 'long' }
        : { month: 'short', year: 'numeric' }
    );
    setDays(getDaysOfMonth(month));
  }, [month]);

  return (
    <Container>
      <MonthLabel>
        <i
          className="icon-angle-left"
          onClick={() => {
            setLeftMonth('previous');
            setRightMonth('previous');
          }}
        />
        <h5>{formatDate(month, options)}</h5>
        <i
          className="icon-angle-right"
          onClick={() => {
            setLeftMonth('next');
            setRightMonth('next');
          }}
        />
      </MonthLabel>
      <WeekLabels>
        {weekdays.map(e => (
          <WeekLabel
            key={e.id}
            current={
              e.id === new Date().getDay() &&
              new Date().getMonth() === month.getMonth() &&
              new Date().getFullYear() === month.getFullYear()
            }
          >
            {e.label}
          </WeekLabel>
        ))}
      </WeekLabels>
      <Days>
        {(() => {
          const d = [];
          // TODO: Fix with settings
          const firstDay = new Date(new Date(month).getFullYear(), new Date(month).getMonth(), 1, hour, minutes);

          if (firstDay.getDay() === 0) {
            for (let i = 0; i < 6; i += 1) {
              d.push(<i key={Math.random()} />);
            }
          } else {
            for (let i = 0; i < firstDay.getDay() - 1; i += 1) {
              d.push(<i key={Math.random()} />);
            }
          }

          for (let i = 1; i <= days; i += 1) {
            const date = new Date(new Date(month).getFullYear(), new Date(month).getMonth(), i, hour, minutes);

            d.push(
              <Day
                key={i.toString()}
                onClick={() => onSelect(date)}
                selectedAsTo={date.getTime() === new Date(to).getTime()}
                selectedAsFrom={date.getTime() === new Date(from).getTime()}
                today={
                  new Date().getDate() === date.getDate() &&
                  new Date().getMonth() === date.getMonth() &&
                  new Date().getFullYear() === date.getFullYear()
                }
                inInterval={date.getTime() > new Date(from).getTime() && date.getTime() < new Date(to).getTime()}
                beforeCurrentDay={
                  new Date(new Date(month).getFullYear(), new Date(month).getMonth(), i + 1).getTime() <
                  getOneMonthBefore().getTime()
                }
              >
                {i}
              </Day>
            );
          }

          return d;
        })()}
      </Days>
    </Container>
  );
};

Month.propTypes = {
  month: PropTypes.instanceOf(Date).isRequired,
  setLeftMonth: PropTypes.func.isRequired,
  setRightMonth: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  from: PropTypes.instanceOf(Date),
  to: PropTypes.instanceOf(Date),
  hour: PropTypes.number.isRequired,
  minutes: PropTypes.number.isRequired
};

Month.defaultProps = {
  from: PropTypes.instanceOf(Date),
  to: PropTypes.instanceOf(Date)
};

export default Month;
